import script from "./TransferToQueue.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransferToQueue.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__